



























import { Component, Prop, Vue } from 'vue-property-decorator';

import CategoryItem from '@/components/molecules/CategoryItem/CategoryItem.vue';
import isMobile from '@/utils/mobile-check';

interface ICategory {
  value: string;
  label: string;
}

export function isOtherCategory(label: string) {
  const regex = /\bother(s)?\b/i;

  return regex.test(label);
}

@Component({
  components: {
    CategoryItem
  }
})
export default class Categories extends Vue {
  @Prop() readonly categories!: ICategory[];
  @Prop({ default: '' }) readonly value?: string;
  @Prop({ default: '' }) readonly otherValue?: string;
  @Prop({ default: [] }) readonly errors?: string[];

  isMobileDevice = isMobile();
  isOtherCategory = isOtherCategory;

  handleOnClick(category: ICategory) {
    if (
      this.value === category.value &&
      !this.isOtherCategory(category.label) &&
      !this.isMobileDevice
    ) {
      this.handleOnClose();

      return;
    }

    this.$emit('changeCategory', category.value);
  }

  handleOutsideItemClick() {}

  handleOnClose() {
    if (this.isMobileDevice) return;

    this.$emit('closeCategory');
  }
}
